<template>
    <div id="card" class="card">
        <div class="header">
            <h3>{{ mark.subject }}</h3>
            <div class="grade-container">
                <span class="grade-text">Cijfer</span>
                <div class="rating-circle" :class="mark.rating == 10 ? 'glow' : ''">
                    <div class="ratings" :style="computedRatingsTransform">
                        <span v-for="(rating, index) in ratings" :key="rating" class="rating" :class="index <= 5 ? 'red' : 'weed-green'">{{ rating }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="description">{{ mark.description }}</div>
        <weed-slider :min="0" :max="10" :value="parseInt(mark.rating)" :index="index" @input="handleSliderInput" @inputEnded="handleInputEnded"></weed-slider>
    </div>
</template>

<script>
import WeedSlider from '@/components/WeedSlider';

export default {
    name: 'FormItem',
    props: {
        // mark object
        mark: {
            type: Object,
            required: true
        },
        // the index of the mark in the array marks
        index: {
            type: Number,
            required: true
        }
    },
    components: {
        WeedSlider
    },
    data() {
        return {
            lastSavedValue: 0,
            ratings: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        }
    },
    methods: {
        handleSliderInput(value) {
            this.$emit('ratingUpdated', { value, index: this.index })
            this.lastSavedValue = value
        },
        handleInputEnded(index) {
            this.$emit('inputEnded', index)
        }
    },
    computed: {
        computedRatingsTransform: function() {
            return `transform: translateY(-${(this.lastSavedValue*10) / 1.1}%)`
        }
    },
    mounted() {
        this.lastSavedValue = this.mark.rating
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.card {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    padding: 18px;
    border-radius: 16px;
    background-color: $card-color;
    box-shadow: 0px 4px 8px rgba(139, 139, 139, 0.25);

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        h3 {
            font-weight: 600;
            font-size: 23px;
            margin: 0;
        }
        .grade-container {
            display: flex;
            align-items: center;

            .grade-text {
                color: #A7A7A7;
                margin-right: 5px;
            }

            .rating-circle {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                background-color: #C4C4C4;
                text-align: center;
                overflow: hidden;
                transition: .4s ease .1s;

                .ratings {
                    display: flex;
                    flex-direction: column;
                    margin-top: -2px;
                    transition: transform .5s ease;

                    .rating {
                        font-size: 20px;
                        color: #ffffff;
                        font-weight: 600;
                        text-shadow: 0px 1px 8px rgba(65, 65, 65, 0.5);
                        padding: 2px 0;

                        &.red {
                            background-color: $warning-red;
                        }
                        &.weed-green {
                            background-color: $weed-green;
                        }
                    }
                }

                &.glow {
                    box-shadow: 0px 0px 2px 1px #4b9e09;
                }
            }
        }
    }

    .description {
        font-size: 17px;
        font-weight: 500;
        color: #707070;
        margin-top: 8px;
    }
}

</style>